import { render, staticRenderFns } from "./farmer_profile.vue?vue&type=template&id=5a4fc8b8&"
import script from "./farmer_profile.vue?vue&type=script&lang=js&"
export * from "./farmer_profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports